// src/App.js
import React, { useState, useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  BrowserRouter as Router,
} from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { AnalysisProvider } from "./contexts/AnalysisContext";
import Sidebar from "./components/Sidebar/Sidebar";
import ProfilePage from "./pages/profilePage";
import AnalyticsDashboard from "./pages/AnalyticsDashboard";
import MapSelectorPage from "./pages/MapSelector";
import SettingsPage from "./pages/SettingsPage";
import AuthPage from "./pages/AuthPage";
import "./App.css";
import logo from "./assets/logo.png";
import WeatherForecast from "./components/analytics/WeatherForecast";
import SoilAnalyse from "./components/soil-analysis/SoilAnalyse";
import ReportVisualization from "./components/analytics/ReportVisualization";
import YieldPrediction from "./components/yield/YieldPrediction";
import Classification from "./components/classification/Classification";
import NotFoundPage from "./pages/page404";
import AdminLogin from "./pages/AdminSide";
import AdminDashboard from "./pages/adminPage";


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userEmail, setUserEmail] = useState(null);
  const auth = getAuth();
  // const [adminAuthenticates, setAdminAuthenticated] = useState(false);
  const location = useLocation();  // Use useLocation to get the current route

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAuthenticated(true);
        setUserEmail(user.email); // Get the user's email
      }
      else {
        setIsAuthenticated(false);
        setUserEmail(null);
      }
      setLoading(false);
    });

    return () => unsubscribe(); // Cleanup the listener when the component unmounts
  }, [auth]);

  if (loading) {
    return (
      <div className="h-screen flex flex-col gap-4 items-center justify-center">
        <div className="bg-green-500 rounded-full w-[100px] h-[100px] flex items-center justify-center p-4 animate-pulse">
          <img src={logo} className="w-full" alt="Company Logo" />
        </div>
        <p className="text-md lg:text-lg 2xl:text-2xl animate-pulse">
          Loading...
        </p>
      </div>
    ); // Or any loading spinner component
  }

  // Determine whether the current route is /report to hide the sidebar
  const hideSidebar = location.pathname === "/report" || location.pathname === "/AdminDashboard" || location.pathname === "/adminlogin" || location.pathname === "/test";
  const isAdminAuth = JSON.parse(localStorage.getItem("AdminFlag"))


  return (
    <div className="App">
      {/* Conditionally render Sidebar based on the current route */}
      {!hideSidebar && isAuthenticated && <Sidebar />}

      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated ? <MapSelectorPage /> : <Navigate to="/auth" />
          }
        />
        <Route
          path="/auth"
          element={
            !isAuthenticated ? (
              <AuthPage />
            ) : (
              <Navigate to="/map-selector" />
            )
          }
        />
        <Route
          path="/map-selector"
          element={
            isAuthenticated ? <MapSelectorPage /> : <Navigate to="/auth" />
          }
        />
        
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="*" element={<NotFoundPage />} />

        <Route
          path="/analytics-dashboard"
          element={
            isAuthenticated ? (
              <AnalyticsDashboard userEmail={userEmail} />
            ) : (
              <Navigate to="/auth" />
            )
          }
        />
        <Route path="/AdminDashboard" element={ isAdminAuth ? <AdminDashboard /> : <Navigate to="/AdminLogin"/>} />
        <Route path="/AdminLogin" element={<AdminLogin />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/yield" element={<YieldPrediction />} />
        <Route path="/classification" element={<Classification />} />
        <Route path="/weather-forecast" element={<WeatherForecast />} />
        <Route
          path="/soil-analysis"
          element={
            isAuthenticated ? <SoilAnalyse /> : <Navigate to="/auth" />
          }
        />
        <Route path="/report" element={<ReportVisualization />} />
      </Routes>
    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      <AnalysisProvider data-theme="light">
        <App />
      </AnalysisProvider>
    </Router>
  );
}

export default AppWrapper;